import type { IMapTilesSource, IPreferences } from "@ports/app"
import type { AppConfig } from "./services/app.config.js"

/**
 * Composition root — the single location that knows every concrete adapter.
 * Mirrors the Lectorium pattern (`initLectorium`/`useLectorium`). Views
 * reach the singleton via `useNavigator()`.
 */
export interface Navigator {
  readonly appConfig: AppConfig
  readonly preferences: IPreferences
  readonly tilesSource: IMapTilesSource
  readonly platform: "ios" | "android" | "web"
}

export interface InitNavigatorSeed {
  readonly appConfig: AppConfig
  readonly preferences: IPreferences
  readonly tilesSource: IMapTilesSource
  readonly platform: "ios" | "android" | "web"
}

let instance: Navigator | null = null

export function initNavigator(seed: InitNavigatorSeed): Navigator {
  if (instance) throw new Error("Navigator already initialized")
  instance = { ...seed }
  return instance
}

export function useNavigator(): Navigator {
  if (!instance) throw new Error("Navigator not initialized — call initNavigator first")
  return instance
}

export function isNavigatorInitialized(): boolean {
  return instance !== null
}

/** Test-only hook: resets the singleton between test cases. */
export function __resetNavigatorForTests(): void {
  instance = null
}
